module.exports = __webpack_public_path__ + "static/media/send-review-request.1c8cad6f.svg";